<template>
    <v-card class="pa-2">
        <v-card-title class="pt-0 pb-0 justify-center"><v-progress-circular indeterminate :size="30"></v-progress-circular></v-card-title>
        <v-card-title class="pt-0 pb-0 justify-center">{{ message }}</v-card-title>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        props: {
            message: {
                type: String,
                required: false,
                default: "Please wait while data is loading ..."
            }
        },
        data() {
            return {
            }
        },
        methods: {
        }
    };
</script> 

<style scoped>
</style>
